module.exports = __webpack_public_path__ + "img/img-carrusel-personas.298bc0e.webp";